import React from 'react';
import { IconProps } from '../Icons.interface';

export const YoutubeOutlineIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99935 3.33337C9.99935 3.33337 4.7873 3.33335 3.4873 3.68168C2.7698 3.87335 2.20599 4.438 2.01432 5.15466C1.66599 6.45466 1.66602 10 1.66602 10C1.66602 10 1.66599 13.5454 2.01432 14.8454C2.20599 15.5629 2.77064 16.1267 3.4873 16.3184C4.7873 16.6667 9.99935 16.6667 9.99935 16.6667C9.99935 16.6667 15.2114 16.6667 16.5114 16.3184C17.2281 16.1267 17.7927 15.5621 17.9844 14.8454C18.3327 13.5454 18.3327 10 18.3327 10C18.3327 10 18.3327 6.45466 17.9844 5.15466C17.7927 4.438 17.2281 3.87335 16.5114 3.68168C15.2114 3.33335 9.99935 3.33337 9.99935 3.33337ZM9.99935 5.00004C12.401 5.00004 15.4084 5.11138 16.0801 5.29138C16.2209 5.32888 16.3363 5.44431 16.3747 5.58598C16.5755 6.33431 16.666 8.61837 16.666 10C16.666 11.3817 16.5755 13.6649 16.3747 14.4141C16.3372 14.5549 16.2217 14.6704 16.0801 14.7087C15.4092 14.8887 12.401 15 9.99935 15C7.59852 15 4.59112 14.8887 3.91862 14.7087C3.77779 14.6712 3.66236 14.5558 3.62402 14.4141C3.42319 13.6658 3.33268 11.3817 3.33268 10C3.33268 8.61837 3.42319 6.33435 3.62402 5.58435C3.66152 5.44435 3.77695 5.32888 3.91862 5.29138C4.58945 5.11138 7.59768 5.00004 9.99935 5.00004ZM8.33268 7.11267L8.33268 12.8874L13.3327 10L8.33268 7.11267Z"
      fill="currentColor"
    />
  </svg>
);
